(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name wbTimedInformationDialog.constant:wbTimedInformationDialog
   *
   * @description
   *
   */
  angular
    .module('wbTimedInformationDialog')
    .constant('wbTimedInformationDialogConstant', {
        // edenredServiceAlert: {
        //   name: 'edenredServiceAlertDialog',
        //   startDate: '2026-02-17 00:01',
        //   endDate: '2026-04-03 23:59',
        //   title: 'Idén is folytatjuk!',
        //   description: '-kedvezmény kuponok az utalványok mellé!<br/><br/>' +
        //     'Kedves Partnerünk!<br/><br/>' +
        //     'Örömmel tájékoztatjuk, hogy minden megrendelőnknek az utalványboríték mellé 1000 Ft kedvezményre jogosító Tesco kupont küldünk.<br /><br />' +
        //     '*Legalább 12 000 Ft összegű áruházi vásárlás esetén, 2026.03.19. - 04.04. között. A kuponokat a készlet erejéig tudjuk biztosítani!<br/><br/>' +
        //     'Reméljük, hogy ezzel a kezdeményezéssel hozzájárulhatunk ahhoz, hogy még nagyobb értéket képviseljen szolgáltatásunk az Önök számára!<br/><br/>' +
        //     'Üdvözlettel,<br/>' +
        //     'Rewin Magyarország Kft.',
        //   onceOnly: false
        // },
        edenredServiceAlert: {
          name: 'edenredServiceAlertDialog',
          startDate: '2026-02-27 00:01',
          endDate: '2026-04-03 23:59',
          title: 'Fontos tudnivalók!',
          description: 'Tájékoztatjuk, hogy az átvételre jogosult személyek a csomag feladása után nem módosíthatóak. A küldeményt csak a korábban megjelölt személyek vehetik át, fényképes igazolvány bemutatásával.<br/>'+
            'Céges bélyegző hiányában az igazolvány számát a szállítólevélen rögzíthetik.<br/><br/>' +
            'Felhívjuk továbbá a figyelmét, hogy minden megrendelőnknek az utalványborítékok mellé kedvezménykuponokat küldünk a készlet erejéig!<br/><br/>' +
            'Köszönjük az együttműködést!<br/>' +
            '<strong>Rewin Magyarország Kft.</strong>',
          onceOnly: false
        },
    }
    );
}());
